import { Statistics as component } from './component'
import { RootState } from 'stores/index'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { getSelectedAnswers, getStatistics } from 'stores/selectors'

const showStatistics = createSelector(
  [getSelectedAnswers, getStatistics],
  (selectedAnswers, statistics) => !!statistics && !!selectedAnswers
)

const mapStateToProps = (state: RootState) => ({
  selectedAnswers: getSelectedAnswers(state),
  statistics: getStatistics(state),
  showStatistics: showStatistics(state)
})

export const Statistics = connect(mapStateToProps)(component)
